export default class DebounceHelper {
    public static createDebounceFunction<T extends any[]>(callback: (...args: [...T, AbortSignal]) => void | Promise<void>,
        delay: number
    ): {
        debouncedFunction: (...args: T) => void;
        abort: () => void;
    } {
        let timer: ReturnType<typeof setTimeout> | null = null;
        let abortController: AbortController | null = null;

        function abort() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            if (abortController) {
                abortController.abort();
                abortController = null;
            }
        }

        const debounce = function (this: any, ...args: T) {
            abort(); // Clear previous timer & abort previous signal
            abortController = new AbortController();
            const signal = abortController.signal;

            timer = setTimeout(() => {
                timer = null;
                callback.apply(this, [...args, signal]);
            }, delay);
        };

        return { debouncedFunction: debounce, abort };
    }
}
